import React from 'react';
import { useContext, useMemo } from 'react';
//mui imports====
import useStyles from './styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Chip } from '@mui/material';
import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
//===============

const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

/**
 * NOTE : This File needs to be deleted, and never be used again.
 * This exists in the codebase to support the old dashboard design.
 */
const AccordionSetting = ({
	label,
	children,
	accordionStyles,
	accordionDetailStyles,
	chipData,
	name,
	system = SYSTEMS.FRAMERATE
}) => {
	const classes = useStyles();
	const { getAccessControlSet } = useContext(UserContext);

	/**
	 * This set contains the access level of this particular accordion setting.
	 * @type {Set<string>}
	 */
	const accordionControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.ACCORDION_NAMES, name);
	}, [name, getAccessControlSet, system]);

	return (
		<>
			{!accordionControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<Accordion className={classes.accordionStyle} style={accordionStyles || {}}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						<Typography variant="h6">{label}</Typography>
						{chipData && <Chip label={chipData} className={classes.chipStyle} />}
					</AccordionSummary>
					<AccordionDetails
						className={classes.accordionDetails}
						style={accordionDetailStyles || {}}
					>
						{children}
					</AccordionDetails>
				</Accordion>
			)}
		</>
	);
};
export default AccordionSetting;
